import type { IconSvgObject } from './types';

const WhistleIcon: IconSvgObject = [
  ["circle", { cx: "8", cy: "15", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 21C11.3137 21 14 18.3137 14 15H18.7929C18.9255 15 19.0527 14.9473 19.1464 14.8536L21.8536 12.1464C21.9473 12.0527 22 11.9255 22 11.7929V9H15.5L15 10.5H12.5L11.5 9H8C4.68629 9 2 11.6863 2 15C2 18.3137 4.68629 21 8 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 5V3M11 6L9.5 4.5M16 6L17.5 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default WhistleIcon;
